var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrushOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3765 3.46676C19.6364 2.81099 18.5107 2.8508 17.8191 3.55724L10.8898 10.4226C10.5337 10.7754 10.5301 11.351 10.8817 11.7083C11.2332 12.0656 11.8069 12.0692 12.163 11.7165L19.098 4.84538C19.1418 4.80108 19.2146 4.82778 19.1679 4.88517L13.0139 12.6268C12.7018 13.0193 12.766 13.5913 13.1572 13.9044C13.5484 14.2175 14.1184 14.1531 14.4304 13.7606L20.5791 6.02574C21.2114 5.25662 21.1211 4.12657 20.3765 3.46676Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.48813 12.6238C6.48546 12.6238 5.01188 14.2541 4.92705 16.1573C4.88524 17.0953 4.47361 17.5732 4.09825 17.8887C3.7159 18.21 3.20393 18.4421 3.04565 18.9538C2.91613 19.3725 3.07853 19.8171 3.41931 20.0822C4.18169 20.6753 5.77364 21.425 8.07334 20.7042C10.4716 19.9525 12.0501 18.1951 12.0501 16.1979C12.0501 14.224 10.4554 12.6238 8.48813 12.6238ZM6.73728 16.2385C6.78353 15.201 7.55711 14.442 8.48813 14.442C9.4546 14.442 10.2381 15.2282 10.2381 16.1979C10.2381 17.1445 9.44948 18.368 7.53306 18.9687C6.66732 19.24 5.98401 19.2166 5.47639 19.0909C6.06541 18.5313 6.67439 17.6495 6.73728 16.2385Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrushOutline);
export default __webpack_public_path__ + "static/media/brush_outline.f37f1098815b3842f6d5f191c893df11.svg";
export { ForwardRef as ReactComponent };